import React from 'react';
import { useTranslation } from 'react-i18next';
import { MortalityCause } from '@/types/cbs';
import { cn } from '@/lib/utils';
import { 
  Thermometer, 
  Snowflake, 
  Wind,
  Bug,
  HelpCircle,
} from 'lucide-react';

// Mortality causes with visual icons for farmers who can't read
const mortalityCauses: { id: MortalityCause; icon: React.ElementType; emoji: string; color: string }[] = [
  { id: 'disease', icon: Bug, emoji: '🦠', color: 'bg-purple-500' },
  { id: 'heat_stress', icon: Thermometer, emoji: '🥵', color: 'bg-red-500' },
  { id: 'cold_stress', icon: Snowflake, emoji: '🥶', color: 'bg-blue-500' },
  { id: 'suffocation', icon: Wind, emoji: '😵', color: 'bg-gray-500' },
  { id: 'unknown', icon: HelpCircle, emoji: '❓', color: 'bg-muted' },
];

interface MortalityCausePickerProps {
  value?: MortalityCause;
  onChange: (cause: MortalityCause) => void;
}

export const MortalityCausePicker: React.FC<MortalityCausePickerProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();
  
  return (
    <div className="grid grid-cols-3 gap-3">
      {mortalityCauses.map((item) => (
        <button
          key={item.id}
          onClick={() => onChange(item.id)}
          className={cn(
            'flex flex-col items-center p-4 rounded-xl border-2 transition-all',
            value === item.id
              ? 'border-primary bg-primary/10 scale-105'
              : 'border-border hover:border-primary/50'
          )}
        >
          <span className="text-4xl mb-2">{item.emoji}</span>
          <span className="text-xs text-center font-medium">
            {t(`cbs.mortality.causes.${item.id}`)}
          </span>
        </button>
      ))}
    </div>
  );
};
